<template>
  <el-dialog
    :visible="dialogVisible"
    title="选择默认 banner"
    width="800px"
    @close="handleClose"
    append-to-body
  >
    <div v-loading="loading">
      <el-row :gutter="20">
        <el-col :span="8" v-for="item in bannerList" :key="item.id">
          <div @click="handleSelect(item)" style="text-align: center; cursor: pointer">
            <el-radio :label="item.id" v-model="selectedId">
              <img :src="item.imgUrl" style="width: 120px; height: 120px; object-fit: cover" />
              <div style="margin-top: 8px">{{ item.name }}</div>
            </el-radio>
          </div>
        </el-col>
      </el-row>
      <el-pagination
        :current-page="pagination.current"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @current-change="handlePageChange"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right"
      />
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { getBannerDefaultPage } from '@/api/bottomBannerDefault'
  export default {
    name: 'DefaultBannerDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: () => null
      },
      slotKey: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        loading: false,
        bannerList: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10
        },
        selectedId: this.value ? this.value.id : null,
        selectedBanner: this.value || null
      }
    },
    watch: {
      visible(val) {
        this.dialogVisible = val
        if (val) {
          this.fetchList(1)
          this.selectedId = this.value ? this.value.id : null
          this.selectedBanner = this.value || null
        }
      }
    },
    methods: {
      async fetchList(page = 1) {
        this.loading = true
        try {
          const res = await getBannerDefaultPage({
            current: page,
            size: this.pagination.pageSize,
            status: 4,
            slotKey: this.slotKey
          })
          this.bannerList = res.data.records
          this.pagination.total = res.data.total
          this.pagination.current = page
        } finally {
          this.loading = false
        }
      },
      handleSelect(item) {
        this.selectedId = item.id
        this.selectedBanner = item
      },
      handlePageChange(page) {
        this.fetchList(page)
      },
      handleConfirm() {
        this.$emit('confirm', this.selectedBanner)
        this.handleClose()
      },
      handleClose() {
        this.dialogVisible = false
        this.$emit('update:visible', false)
        this.$emit('close')
      }
    }
  }
</script>
